import { apiCall } from "@/common/api/ApiResult.model";
import axios from "axios";
import { PolicyEmailTemplate } from "./model";
import "./mock/api.mock";

export const load_email_template = apiCall<
  { feature_id: string; info_type: string },
  PolicyEmailTemplate
>("policy-email-template.get", async ({ feature_id, info_type }) => {
  const res = await axios.get(
    `/notification/template/feature/${feature_id}/infotype/${info_type}`
  );
  return {
    success: true,
    value: res.data,
  };
});

export const update_email_template = apiCall<
  {
    common_id: string;
    id: string;
    placeholdersMap: Record<string, string>;
    name: string;
    feature_id: string;
    info_type: string;
    template: string;
  },
  boolean
>(
  "policy-email-template.update",
  async ({
    feature_id,
    info_type,
    name,
    id,
    common_id,
    placeholdersMap,
    template,
  }) => {
    const res = await axios.put(
      `/notification/template/feature/${feature_id}/infotype/${info_type}`,
      {
        id,
        commonTemplateId: common_id,
        name,
        placeholdersMap,
        template,
      }
    );
    return {
      success: true,
      value: res.data,
    };
  }
);
